var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "auto dropDownAgency" },
    [
      _c(
        "multiselect",
        {
          attrs: {
            "deselect-label": "",
            "select-label": "",
            "open-direction": "bottom",
            "track-by": "id",
            label: "name",
            options: _vm.acAgencies,
            multiple: false,
            placeholder: "Busque por agencia",
            "show-no-results": false,
          },
          on: { select: _vm.selectOpt },
        },
        [
          _c("template", { slot: "noOptions" }, [
            _c("span", {
              domProps: { innerHTML: _vm._s("Digite el nombre de la agencia") },
            }),
          ]),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }